import { render, staticRenderFns } from "./FinishInfoAndPay.vue?vue&type=template&id=61732674&scoped=true&lang=html"
import script from "./FinishInfoAndPay.vue?vue&type=script&lang=js"
export * from "./FinishInfoAndPay.vue?vue&type=script&lang=js"
import style0 from "./FinishInfoAndPay.vue?vue&type=style&index=0&id=61732674&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61732674",
  null
  
)

export default component.exports